var map = {
	"./06.jpg": 628,
	"./08.jpg": 5222,
	"./10.jpg": 8291,
	"./benjaficus01.jpg": 8598,
	"./benjaficus02.jpg": 846,
	"./benjaficus03.jpg": 2836,
	"./bg-1.jpg": 3545,
	"./bg-3.jpg": 7143,
	"./bg-4.jpg": 4811,
	"./prismadacolina01.jpg": 2335,
	"./prismadacolina02.jpg": 3005,
	"./prismadacolina03.jpg": 6476,
	"./prismadacolina04.jpg": 2936,
	"./together01.jpg": 6766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6774;